import { defineMessages } from 'react-intl';

export default defineMessages({
  youBorrowed: { defaultMessage: 'You borrowed' },
  walletBalance: { defaultMessage: 'Wallet balance' },
  yourCollateral: { defaultMessage: 'Your collateral' },
  loanToValue: { defaultMessage: 'Loan to value' },
});
